import { useEffect, useState } from 'react'

export default function usePageActivity() {
  const [active, setActive] = useState(false)
  useEffect(() => {
    const update = () => setActive(!document.hidden && document.hasFocus())
    update()
    document.addEventListener('visibilitychange', update)
    window.addEventListener('focus', update)
    window.addEventListener('blur', update)
    return () => {
      document.removeEventListener('visibilitychange', update)
      window.removeEventListener('focus', update)
      window.removeEventListener('blur', update)
    }
  }, [])
  return active
}
